import { CALLBACK__toast, CALLBACK__translation } from '@/types/types';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { create_file_data } from './utils_upload';

export class UTILS__clipboard {
  static async get_image_file_data_from_clipboard(toast: CALLBACK__toast, t_base_ui: CALLBACK__translation) {
    let out = DTO__file_data.CREATE_STUB();

    // 1. Check permission first to avoid throwing unhandled exceptions
    const permission_status = await navigator.permissions.query({ name: 'clipboard-read' as PermissionName });

    if (permission_status.state === 'denied') return out;

    // 2. Read clipboard items
    const items = await navigator.clipboard.read();

    for (const item of items) {
      // Find the first MIME type that starts with 'image/'
      const image_type = item.types.find(type => type.startsWith('image/'));

      if (!image_type) continue;

      // Await the raw Blob data directly
      const blob = await item.getType(image_type);

      // Convert the Blob into a File object
      const extension = image_type.split('/')[1] || 'png';
      const file = new File([blob], `clipboard-image.${extension}`, { type: image_type });

      out = await create_file_data(file, toast, t_base_ui);
      // Update state with the first file and exit the loop immediately
    }

    return out;
  }
}
